var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
var messages = defineMessages({
    coupon_bet_placed: {
        id: 'coupon.bet_placed',
        defaultMessage: 'Bet placed'
    },
});
var QuickBetSuccess = function (props) {
    var oneClickModalContentCls = props.isOneClick ? 'one-click' : '';
    return (_jsxs("div", __assign({ className: "new-betslips ".concat(props.show ? 'active' : '') }, { children: [_jsx("div", { className: 'new-betslips__overlay', onClick: props.closeModal }), _jsx("div", __assign({ className: "new-betslips__content ".concat(oneClickModalContentCls) }, { children: _jsxs("div", __assign({ className: 'empty-coupon' }, { children: [_jsx("img", { src: require('./../../../assets/img/tick.svg'), alt: '' }), _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_bet_placed)) })), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ type: 'button', className: 'close', onClick: props.closeModal }, { children: "OK" })) }))] })) }))] })));
};
export default QuickBetSuccess;



// WEBPACK FOOTER //
// ./src/components/coupon/quickbet/QuickBetSuccess.jsx